import React, { useState, useEffect } from 'react';
import ResultsShowcase from './components/ResultsShowcase';
import LoginScreen from './components/LoginScreen';

/**
 * Main App component
 * Handles authentication and renders either LoginScreen or ResultsShowcase
 */
function App() {
  // Check if user is already authenticated
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('aidojo2025_auth') === 'true'
  );

  // Handle successful login
  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
      localStorage.setItem('aidojo2025_auth', 'true');
    }
  };

  // Optional: Handle logout (for testing purposes)
  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('aidojo2025_auth');
  };

  // Add logout capability with keyboard shortcut (Alt+L) for testing
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey && e.key === 'l') {
        handleLogout();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Render login screen or results showcase based on authentication status
  return isAuthenticated ? (
    <ResultsShowcase />
  ) : (
    <LoginScreen onLogin={handleLogin} />
  );
}

export default App;